import React from 'react';
import { SupervisorTeamBox } from './SupervisorTeamBox';
import { supTeamRoleTypeMigrateMappings } from './options';
import { PAGE_TEXT } from '../../lang';
import { type SupervisorValue } from '../../../graphql/NominationForm';
import { Accordion } from '../../../../../components';

type SupervisorTeamProps = {
  supervisorTeam: SupervisorValue[];
  isPendingCoSup: boolean;
  refetchSupervisorTeam: () => void;
};

export const SupervisorTeam: React.FunctionComponent<SupervisorTeamProps> = (
  props: SupervisorTeamProps,
) => {
  const { refetchSupervisorTeam, supervisorTeam, isPendingCoSup } = props;

  let otherSupervisors: SupervisorValue[] = [];
  // should slice the chief first
  const supervisorsTeamMembers = supervisorTeam?.slice(
    1,
    supervisorTeam.length,
  );

  if (supervisorsTeamMembers?.length > 0) {
    const supervisorsTeamMembersMigrated = supervisorsTeamMembers?.map(
      member => {
        const { type, ...other } = member;
        return {
          type: supTeamRoleTypeMigrateMappings[type] ?? type,
          ...other,
        };
      },
    );
    otherSupervisors = supervisorsTeamMembersMigrated;
  }

  return (
    <Accordion
      className="w-full !mt-4"
      title={PAGE_TEXT.SUPERVISOR_TEAM.TITLE}
      defaultExpanded
      disableExpand
      details={
        <SupervisorTeamBox
          isPendingCoSup={isPendingCoSup}
          chiefSupervisor={supervisorTeam?.[0]}
          otherSupervisors={otherSupervisors}
          refetchSupervisorTeam={refetchSupervisorTeam}
        />
      }
    />
  );
};
